<section class="popular-links-desktop">
  <div #productCarousel class="popular-links-desktop__grid">
    <span
      (click)="clickLeftArrow(); onProductCarouselNavigation(DIRECTION.LEFT)"
      *ngIf="canScrollLeft()"
      class="popular-links-desktop__grid__arrow"
    >
      <mm-icon name="chevron-small-left"></mm-icon>
    </span>
    <ng-container *ngFor="let card of cardList">
      <app-popular-links-card
        class="popular-links-desktop__grid__card"
        [card]="card"
        appDisableClickEvent
      ></app-popular-links-card>
    </ng-container>
    <span
      (click)="clickRightArrow(); onProductCarouselNavigation(DIRECTION.RIGHT)"
      *ngIf="canScrollRight()"
      class="popular-links-desktop__grid__arrow"
    >
      <mm-icon name="chevron-small-right"></mm-icon>
    </span>
  </div>
</section>
